import productGalleryHtml from "../views/productGallery.component.html";
import ProductImagesCollection from "../classes/productImagesCollection";
import ProductGalleryLargeHtml from "../views/productGalleryLarge.view.html";

class ProductGalleryController {
    constructor($scope, $uibModal, $window) {
        'ngInject';

        this.$scope = $scope;
        this.$uibModal = $uibModal;
        this.$window = $window;

        this.images = [];
        this.blankImages = [];

        this.thumbnailsInRow = this.getThumbnailsInRowValue();
        this.currentThumbnailIndex = 0;
        this.currentImageIndex = null;
        this.activeImage = null;
        this.drag = false;

        this.imagesCollection = new ProductImagesCollection($scope, []);

        this.imagesCollection.registerEvent('onActiveImageChanged', () => {
            this.setThumbnailsPosition();
        });

        angular.element($window).bind('resize', () => {
            if(this.getThumbnailsInRowValue() !== this.thumbnailsInRow) {
                this.thumbnailsInRow = this.getThumbnailsInRowValue();
                // Reset thumbnails slider position when the number of displayed items had changed
                this.setThumbnailsPosition();
                this.$scope.$apply();
            }
        });

        this.$scope.$on('stopDrag', (event, direction) => {
            if(direction === 'prev') {
                this.imagesCollection.prevPhoto();
            } else if(direction === 'next') {
                this.imagesCollection.nextPhoto();
            }
        });
    }

    $onInit() {
        this.currentImageIndex = 0;
        this.imagesCollection.images = this.images;

        if (this.images.length < this.getThumbnailsInRowValue()) {
            this.blankImages = [];
            for (let i = 0; i < this.getThumbnailsInRowValue() - this.images.length; i++) {
                this.blankImages.push(i);
            }
        }

        if (this.selectedVariant) {
            if (this.selectedVariant.images.count > 0) {
                this.displayProductImage(this.selectedVariant);
            } else if (this.selectedVariant.parentProduct) {
                this.displayProductImage(this.selectedVariant.parentProduct);
            }
        }

        // Watch variant changes and then display changed variant image
        this.$scope.$watch(() => {
            return this.selectedVariant;
        }, (product) => {
            if (product) {
                this.displayProductImage(product);
            }
        });
    }

    isMobile() {
        return this.$window.innerWidth <= 575;
    }

    getThumbnailsInRowValue() {
        if (this.isMobile()) {
            return 1;
        }

        return 4;
    }

    showModal() {
        if (this.isMobile()) {
            return;
        }

        let imagesCollection = this.imagesCollection;

        let modalInstance = this.$uibModal.open({
            animation: 'false',
            size: 'md',
            template: ProductGalleryLargeHtml,
            controller: 'ProductGalleryLargeController',
            windowClass: 'product-large-image',
            backdropClass: 'product-large-image',
            resolve: {
                imagesCollection: function () {
                    return imagesCollection;
                },
                parent: this
            }
        });

        modalInstance.result.then((data) => {
            console.log('result data', data);
        });
    }

    // Display specified product image
    displayProductImage(product) {
        const image = this.images.find(image => {
            if (image.productId === product.id) {
                return image;
            }
        });

        if (image) {
            this.imagesCollection.setCurrentImage(image);

            return;
        }
    }

    // Scroll thumbnails bar to match selected image
    setThumbnailsPosition() {
        let newThumbnailIndex = this.imagesCollection.currentImageIndex;
        if (newThumbnailIndex > (this.images.length - this.thumbnailsInRow)
            && (this.images.length - this.thumbnailsInRow) >= 0) {
            newThumbnailIndex = this.images.length - this.thumbnailsInRow;
        }
        if (this.images.length <= this.thumbnailsInRow) {
            newThumbnailIndex = 0;
        }
        this.currentThumbnailIndex = newThumbnailIndex;
    }

    get thumbnailSliderPosition() {
        return (-this.currentThumbnailIndex * (100 / this.thumbnailsInRow)) + '%';
    }

    hasNextThumbnail() {
        return this.currentThumbnailIndex + this.thumbnailsInRow < this.images.length;
    }

    hasPrevThumbnail() {
        return this.currentThumbnailIndex > 0;
    }

    nextThumbnail() {
        if (this.hasNextThumbnail()) {
            this.currentThumbnailIndex++;
        }
    }

    prevThumbnail() {
        if (this.hasPrevThumbnail()) {
            this.currentThumbnailIndex--;
        }
    }

    startDrag() {
        this.drag = true;
    }

    stopDrag() {
        this.drag = false;
    }

    drag() {

    }
}

let productGalleryComponent = {
    bindings: {
        images: '<',
        selectedVariant: '<'
    },
    template: productGalleryHtml,
    controller: ProductGalleryController
}

export default productGalleryComponent;
